import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useRecoilState } from "recoil";
import { userStateAtom } from "./atoms/userStateAtom";
import axios from "axios";
import moment from "moment";
import Loading from "./components/Loading";
import Login from "./screens/Login";
import { ErrorBoundary } from "./ErrorBoundary";
import { reportError } from "./errorReporter";

function App() {
  const [userState, setUserState] = useRecoilState<any>(userStateAtom);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // You can add any initialization code here if needed
    setLoading(false);

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      event.preventDefault();
      reportError(event.reason, "Unhandled Promise Rejection");
    };

    const handleGlobalError = (event: ErrorEvent) => {
      event.preventDefault();
      reportError(event.error, "Global Error Handler");
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleGlobalError);

    return () => {
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
      window.removeEventListener("error", handleGlobalError);
    };
  }, []);

  return (
    <ErrorBoundary>
      {loading ? (
        <Loading />
      ) : userState.isLoggedIn ? (
        <div
          translate="no"
          style={{ height: "150vh" }}
          className="bg-gray-200 dark:bg-gray-700"
        >
          <Header />
          <Outlet />
          <ScrollRestoration />
        </div>
      ) : (
        <Login />
      )}
    </ErrorBoundary>
  );
}

export default App;
